// Image Generator Tool - Entry Point
import { ImageGeneratorTool } from '../../src/tools/image-generator/ImageGeneratorTool';
import '../../src/utils/emojiManager';

// Initialize the tool when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
  const tool = new ImageGeneratorTool();
  await tool.init();
});
